import ReactGA from 'react-ga4'

export function sendReactGAEvent(category: string, action: string, label: string = ''): void {
    ReactGA.event({ category, action, label })
}